import { AxiosError } from 'axios';
import type { CommentErrorCode } from '@/lib/comments/types';

/**
 * Map a failed comments request to the inline message the section shows (there
 * is no global toast system — feedback is in-place). `KYC_REQUIRED` returns
 * null: the global 403 interceptor already opens the KYC gate and replays the
 * request, so surfacing a message would double up.
 */
export function commentErrorMessage(error: unknown): string | null {
  const code = error instanceof AxiosError ? (error.response?.data?.code as CommentErrorCode | undefined) : undefined;
  switch (code) {
    case 'KYC_REQUIRED':
      return null;
    case 'COMMENT_BANNED':
      return 'You are currently not allowed to comment.';
    case 'COMMENT_RATE_LIMITED':
      return (
        (error as AxiosError<{ message?: string }>).response?.data?.message ?? 'Slow down a little — try again shortly.'
      );
    case 'COMMENT_PROFANITY':
      return "Your comment couldn't be posted because it contains content that isn't allowed. Please edit it and try again.";
    default:
      return 'Something went wrong — please try again.';
  }
}
